import { render, staticRenderFns } from "./SelectSeatDescription.vue?vue&type=template&id=31bd6270&scoped=true&"
import script from "./SelectSeatDescription.vue?vue&type=script&lang=ts&"
export * from "./SelectSeatDescription.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSeatDescription.vue?vue&type=style&index=0&id=31bd6270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd6270",
  null
  
)

export default component.exports